const translations = {
  destinationLabel: {
    _: 'Where will you travel?',
    'zh-hk': '你將去哪裡旅行？',
  },
  destinationTooltip: {
    _: 'Select one or more destinations for your trip. Your premium will be calculated based on the destinations you choose.',
    'zh-hk': '選擇一個或多個旅行目的地。您的保費將根據您選擇的目的地計算。',
  },
  travelDatesLabel: {
    _: 'Dates of travel',
    'zh-hk': '旅行日期',
  },
  travelDatesTooltip: {
    _: 'Select your departure and return dates. The travel period must be within the policy limits.',
    'zh-hk': '選擇您的出發和返回日期。旅行期限必須在保單限制範圍內。',
  },
  adultsLabel: {
    _: 'Adults',
    'zh-hk': '成人',
  },
  adultsTooltip: {
    _: 'Number of adults traveling (18 years and above)',
    'zh-hk': '旅行的成人數量（18歲及以上）',
  },
  childrenLabel: {
    _: 'Children',
    'zh-hk': '兒童',
  },
  childrenTooltip: {
    _: 'Number of children traveling (under 18 years)',
    'zh-hk': '旅行的兒童數量（18歲以下）',
  },
  tripDetailsLabel: {
    _: 'Your trip details',
    'zh-hk': '您的旅行詳情',
  },
  tripDetailsTooltip: {
    _: 'Review your trip details',
    'zh-hk': '查看您的旅行詳情',
  },
  editButtonLabel: {
    _: 'Edit',
    'zh-hk': '編輯',
  },
  modalTitle: {
    _: 'Change your trip details',
    'zh-hk': '更改您的旅行詳情',
  },
  findBestDealButton: {
    _: 'Find Best Deal',
    'zh-hk': '尋找最佳優惠',
  },
  travelingAsFamilyLabel: {
    _: "We're traveling as a family",
    'zh-hk': '我們以家庭身份旅行',
  },
  travelingAsFamilyTooltip: {
    _: 'Family refers to at most 2 adults (insured person & legal spouse), and children below 18 years old.',
    'zh-hk':
      '家庭指的是最多兩名家長(受保人及其合法配偶)以及其18歲以下子女。有關家庭的具體定義,請參閱保險公司的產品小冊子。',
  },
  familyModalHeadline: {
    _: 'Traveling as a Family?',
    'zh-hk': '以家庭身份旅行？',
  },
  familyModalBody: {
    _: 'A family plan covers up to 2 adults (you and your spouse) + children under 18.',
    'zh-hk': '家庭計劃包括最多 2 位成人（您及您的配偶）和 18 歲以下子女。',
  },
  familyModalYes: {
    _: 'Yes',
    'zh-hk': '是',
  },
  familyModalNo: {
    _: 'No',
    'zh-hk': '否',
  },
  close: {
    _: 'Close',
    'zh-hk': '關閉',
  },
  SINGLE_PLAN: {
    _: 'Single-Trip',
    'zh-hk': '單次計劃',
  },
  ANNUAL_PLAN: {
    _: 'Annual',
    'zh-hk': '全年旅程',
  },
};

export default translations;
